module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="l-device-status">\n				<div class="l-device-status__overview status-region">\n				</div>\n				<div class="l-device-status__charts">\n				<div class="l-device-status__tabs tabs-region"></div>\n				';
 if(showFetchButtons()) { 
__p+='\n				<div class="l-device-status__controls"><a class="m-btn js-control-button" role="button" data-command="modbus_registers.get.register">Fetch register</a></div>\n				';
 } 
__p+='\n				<div class="sensors-region"></div>\n				</div>\n\n			</div>\n</div>\n\n\n\n<!-- 				<div class="l-device-status__overview">\n					<ul class="l-device-status-overview__list">\n						<li class="l-device-status-overview__item">\n							<div class="label">Last seen</div>\n							<div class="value">'+
((__t=( getLastSeenAt() ))==null?'':__t)+
'</div>\n						</li>\n						<li class="l-device-status-overview__item">\n							<div class="label">Casing</div>\n							<div class="value"><span class="m-status-indicator is-'+
((__t=( getConditionalStr(getSensorValue('tamper'), 'negative', 'positive') ))==null?'':__t)+
'">'+
((__t=( getConditionalStr(getSensorValue('tamper'), 'opened', 'closed') ))==null?'':__t)+
'</span></div>\n						</li>\n						<li class="l-device-status-overview__item">\n							<div class="label">Rssi</div>\n							<div class="value">'+
((__t=( getSensorValue('rf') ))==null?'':__t)+
'</span></div>\n						</li>\n					</ul>\n				</div> -->';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./js/modules/device-status/show/templates/layout.html
// module id = 427
// module chunks = 0